export function removeEmptyFields<T extends Record<string, any>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== undefined && value !== null && value !== '')
  ) as Partial<T>;
}

export function removeDashes(guid: string): string {
  return guid.replace(/-/g, '');
}
